import { AlertCircle, Loader2, RefreshCw, X } from 'lucide-react'

interface PaymentFailedModalProps {
  isOpen: boolean
  message: string
  bookingNumber?: number
  isRetrying?: boolean
  onRetry: () => void
  onClose: () => void
}

const PaymentFailedModal = ({
  isOpen,
  message,
  bookingNumber,
  isRetrying = false,
  onRetry,
  onClose,
}: PaymentFailedModalProps) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-[2px]" onClick={onClose} />
      <div
        className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="px-6 pt-8 pb-6 text-center">
          <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-red-100 flex items-center justify-center">
            <AlertCircle className="h-7 w-7 text-red-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Payment Failed</h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            {message || 'Your payment was not completed. Please try again to confirm your booking.'}
          </p>
          {bookingNumber ? (
            <p className="mt-3 text-xs text-gray-500">
              Booking reference: <span className="font-mono font-semibold text-gray-700">{bookingNumber}</span>
            </p>
          ) : null}
        </div>

        <div className="px-6 pb-6 flex flex-col sm:flex-row gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isRetrying}
            className="flex-1 px-4 py-2.5 text-sm font-semibold text-gray-700 border-2 border-gray-200 rounded-xl hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            Back to payment
          </button>
          <button
            type="button"
            onClick={onRetry}
            disabled={isRetrying}
            className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold text-white bg-primary-500 rounded-xl hover:bg-primary-600 transition-colors disabled:opacity-50"
          >
            {isRetrying ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Retrying...
              </>
            ) : (
              <>
                <RefreshCw className="h-4 w-4" />
                Retry payment
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default PaymentFailedModal
